/* TGB 300 Funnel - shared behaviour for the tgb-300-* sections.
   Safe to load more than once (guarded). Every component is independent:
   if its DOM is absent it does nothing and throws nothing. */
(function () {
  'use strict';
  if (window.tgbfFunnel) { return; }

  /* Guards are per feature, not global. One shared set meant every initialiser
     competed for the same "already handled" flag on the same node: the spectrum
     div is BOTH a .tgbf-reveal and a [data-tgbf-spectrum], so initReveal claimed
     it first and initSpectrum then bailed out - the pigment swatches could never
     render on any page load. Anything that hangs two behaviours off one element
     would have hit the same wall. */
  var seen = {};
  function fresh(el, feature) {
    var set = seen[feature] || (seen[feature] = new WeakSet());
    if (set.has(el)) { return false; }
    set.add(el);
    return true;
  }
  function attr(el, name, fallback) {
    var v = el && el.getAttribute(name);
    return v === null || v === undefined || v === '' ? (fallback || '') : v;
  }
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var hasIO = 'IntersectionObserver' in window;

  /* ---------------- scroll reveal ---------------- */
  var revealObserver = null;
  if (!reduceMotion && hasIO) {
    revealObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          revealObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });
  }
  function initReveal(scope) {
    scope.querySelectorAll('.tgbf-reveal').forEach(function (el) {
      if (!fresh(el, 'reveal')) { return; }
      if (revealObserver) { revealObserver.observe(el); } else { el.classList.add('is-in'); }
    });
  }

  /* ---------------- hero gallery ---------------- */
  function initGallery(scope) {
    scope.querySelectorAll('[data-tgbf-gallery]').forEach(function (root) {
      if (!fresh(root, 'gallery')) { return; }
      var first = root.querySelector('[data-tgbf-thumb]');
      if (first) { first.classList.add('is-active'); }
    });
  }
  function selectGalleryImage(root, thumb) {
    var main = root.querySelector('.tgbf-hero__main img');
    var full = thumb.getAttribute('data-full');
    if (!main || !full) { return; }
    main.removeAttribute('srcset');
    main.removeAttribute('sizes');
    main.src = full;
    main.alt = thumb.getAttribute('data-alt') || '';
    root.querySelectorAll('[data-tgbf-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
    thumb.classList.add('is-active');
    if (thumb.scrollIntoView) {
      thumb.scrollIntoView({ block: 'nearest', inline: 'center', behavior: reduceMotion ? 'auto' : 'smooth' });
    }
  }
  document.addEventListener('click', function (ev) {
    var nav = ev.target.closest ? ev.target.closest('[data-tgbf-gallery-nav]') : null;
    if (nav) {
      var navRoot = nav.closest('[data-tgbf-gallery]');
      var thumbs = navRoot ? Array.prototype.slice.call(navRoot.querySelectorAll('[data-tgbf-thumb]')) : [];
      if (!thumbs.length) { return; }
      var current = thumbs.findIndex(function (thumb) { return thumb.classList.contains('is-active'); });
      var direction = nav.getAttribute('data-tgbf-gallery-nav') === 'prev' ? -1 : 1;
      var next = (current + direction + thumbs.length) % thumbs.length;
      selectGalleryImage(navRoot, thumbs[next]);
      return;
    }
    var thumb = ev.target.closest ? ev.target.closest('[data-tgbf-thumb]') : null;
    if (!thumb) { return; }
    var root = thumb.closest('[data-tgbf-gallery]');
    if (!root) { return; }
    selectGalleryImage(root, thumb);
  });

  /* ---------------- pigment spectrum ---------------- */
  function parsePigments(raw) {
    return raw.split('\n').map(function (line) {
      var bits = line.split('|');
      return [(bits[0] || '').trim(), (bits[1] || '').trim()];
    }).filter(function (p) { return p[0] && p[1]; });
  }
  function initSpectrum(scope) {
    scope.querySelectorAll('[data-tgbf-spectrum]').forEach(function (el) {
      if (!fresh(el, 'spectrum')) { return; }
      var list = parsePigments(attr(el, 'data-tgbf-pigments'));
      var limit = parseInt(attr(el, 'data-tgbf-limit', '0'), 10);
      if (limit > 0) { list = list.slice(0, limit); }
      var named = attr(el, 'data-tgbf-named') === 'true';
      list.forEach(function (p, i) {
        var tile = document.createElement('span');
        tile.style.background = p[1];
        if (named) {
          tile.setAttribute('data-name', p[0]);
          tile.setAttribute('title', p[0]);
          tile.style.transitionDelay = (i * 22) + 'ms';
        }
        el.appendChild(tile);
      });
    });
  }

  /* ---------------- countdown ---------------- */
  function daysLeft(el) {
    var raw = attr(el, 'data-tgbf-deadline');
    if (!raw) { return null; }
    var deadline = new Date(raw + 'T00:00:00');
    if (isNaN(deadline.getTime())) { return null; }
    var ms = deadline.getTime() - Date.now();
    if (ms <= 0) { return null; }
    return Math.ceil(ms / 86400000);
  }
  function fill(tpl, n) { return tpl.split('[days]').join(n); }
  function initCountdown(scope) {
    scope.querySelectorAll('[data-tgbf-countdown]').forEach(function (el) {
      if (!fresh(el, 'countdown')) { return; }
      var n = daysLeft(el);
      if (n === null) { return; }
      var today = attr(el, 'data-tgbf-today');
      var days = attr(el, 'data-tgbf-days');
      if (!today && !days) { return; }
      // Strings come from theme settings and may carry the <span data-tgb-money> that
      // snippets/tgb-price-tokens.liquid emits, so they are HTML, not text.
      el.innerHTML = (n <= 1 ? today : fill(days, n)) + attr(el, 'data-tgbf-suffix');
      if (window.tgbMoney) { window.tgbMoney.format(el); }
    });
  }

  /* ---------------- floating buy bar ---------------- */
  function syncBodyPadding() {
    if (!document.querySelector('[data-tgbf-stickybar]')) {
      document.body.classList.remove('tgbf-has-stickybar');
    }
  }
  function initSticky(scope) {
    scope.querySelectorAll('[data-tgbf-stickybar]').forEach(function (bar) {
      if (!fresh(bar, 'sticky')) { return; }
      function setVisible(visible) {
        bar.classList.toggle('is-visible', visible);
        bar.setAttribute('aria-hidden', String(!visible));
        document.body.classList.toggle('tgbf-has-stickybar', visible);
      }
      /* Watch the hero's own buy form, not the whole hero: on mobile the gallery
         stacks above it, so tying the bar to the hero left visitors with no buy
         button at all until they had scrolled past the entire first section. */
      var hero = document.querySelector('[data-tgbf-hero]');
      var heroBuy = hero && (hero.querySelector('.tgbf-form') || hero);
      if (heroBuy && hasIO) {
        new IntersectionObserver(function (entries) {
          setVisible(!entries[0].isIntersecting);
        }, { rootMargin: '-80px 0px 0px 0px' }).observe(heroBuy);
        return;
      }
      var threshold = parseInt(attr(bar, 'data-tgbf-threshold', '600'), 10);
      if (!(threshold > 0)) { threshold = 600; }
      var check = function () { setVisible(window.scrollY > threshold); };
      window.addEventListener('scroll', check, { passive: true });
      check();
    });
  }

  /* ---------------- long-form reading panel ---------------- */
  var FOCUSABLE = 'a[href],button:not([disabled]),input:not([disabled]):not([type="hidden"]),' +
    'select:not([disabled]),textarea:not([disabled]),iframe,summary,[tabindex]:not([tabindex="-1"])';
  var openPanelCount = 0;

  function focusables(root) {
    return Array.prototype.filter.call(root.querySelectorAll(FOCUSABLE), function (el) {
      return el.offsetWidth > 0 || el.offsetHeight > 0 || el.getClientRects().length > 0;
    });
  }
  /* Locking is refcounted: two panels on one page must not unlock each other. */
  function lockScroll() {
    openPanelCount++;
    if (openPanelCount > 1) { return; }
    var gap = window.innerWidth - document.documentElement.clientWidth;
    document.documentElement.style.setProperty('--tgbf-scrollbar', (gap > 0 ? gap : 0) + 'px');
    if (gap > 0) { document.body.style.paddingRight = gap + 'px'; }
    document.documentElement.classList.add('tgbf-scroll-locked');
    document.body.classList.add('tgbf-scroll-locked');
  }
  function releaseScroll() {
    openPanelCount = 0;
    document.documentElement.classList.remove('tgbf-scroll-locked');
    document.body.classList.remove('tgbf-scroll-locked');
    document.body.style.paddingRight = '';
    document.documentElement.style.removeProperty('--tgbf-scrollbar');
  }
  function unlockScroll() {
    openPanelCount = Math.max(0, openPanelCount - 1);
    if (openPanelCount === 0) { releaseScroll(); }
  }
  /* A section removed by the theme editor while its panel was open would strand the lock. */
  function syncScrollLock() {
    if (!document.querySelector('.tgbf-readpanel.is-open')) { releaseScroll(); }
  }

  function initReadpanel(scope) {
    scope.querySelectorAll('[data-tgbf-readpanel]').forEach(function (panel) {
      if (!fresh(panel, 'readpanel')) { return; }
      var dialog = panel.querySelector('.tgbf-readpanel__dialog');
      var trigger = panel.id
        ? document.querySelector('[data-tgbf-readpanel-open][aria-controls="' + panel.id + '"]')
        : null;
      if (!dialog || !trigger) { return; }
      var returnTo = null;
      var hideTimer = null;

      function isOpen() { return panel.classList.contains('is-open'); }

      function onKeydown(ev) {
        if (!isOpen()) { return; }
        if (ev.key === 'Escape' || ev.key === 'Esc') { ev.preventDefault(); close(); return; }
        if (ev.key !== 'Tab') { return; }
        var items = focusables(dialog);
        if (!items.length) { ev.preventDefault(); dialog.focus(); return; }
        var first = items[0];
        var last = items[items.length - 1];
        var active = document.activeElement;
        var inside = dialog.contains(active) && active !== dialog;
        if (ev.shiftKey) {
          if (!inside || active === first) { ev.preventDefault(); last.focus(); }
        } else if (!inside || active === last) {
          ev.preventDefault(); first.focus();
        }
      }

      function open() {
        if (isOpen()) { return; }
        if (hideTimer) { clearTimeout(hideTimer); hideTimer = null; }
        returnTo = document.activeElement;
        panel.hidden = false;
        lockScroll();
        /* read a layout property so the transition has a start frame to animate from */
        void panel.offsetWidth;
        panel.classList.add('is-open');
        trigger.setAttribute('aria-expanded', 'true');
        document.addEventListener('keydown', onKeydown, true);
        dialog.focus();
      }

      function close() {
        if (!isOpen()) { return; }
        panel.classList.remove('is-open');
        trigger.setAttribute('aria-expanded', 'false');
        document.removeEventListener('keydown', onKeydown, true);
        unlockScroll();
        if (returnTo && returnTo.focus) { returnTo.focus(); }
        returnTo = null;
        if (reduceMotion) {
          panel.hidden = true;
        } else {
          hideTimer = setTimeout(function () { panel.hidden = true; hideTimer = null; }, 420);
        }
      }

      trigger.addEventListener('click', function () { if (isOpen()) { close(); } else { open(); } });
      panel.querySelectorAll('[data-tgbf-readpanel-close]').forEach(function (el) {
        el.addEventListener('click', function (ev) { ev.preventDefault(); close(); });
      });
    });
  }

  /* ---------------- collage safety net (delegated, capture phase) ---------------- */
  document.addEventListener('error', function (ev) {
    var img = ev.target;
    if (!img || img.tagName !== 'IMG' || !img.closest) { return; }
    if (!img.closest('.tgbf-collage, .tgbf-band__grid, .tgbf-reviews__photos')) { return; }
    var fig = img.closest('figure');
    if (fig) { fig.style.display = 'none'; } else { img.style.display = 'none'; }
  }, true);

  function initAll(scope) {
    var root = scope || document;
    initReveal(root);
    initGallery(root);
    initSpectrum(root);
    initCountdown(root);
    initSticky(root);
    initReadpanel(root);
    syncBodyPadding();
  }
  window.tgbfFunnel = { init: initAll };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }
  document.addEventListener('shopify:section:load', function (ev) { initAll(ev.target || document); });
  document.addEventListener('shopify:section:unload', function () { syncBodyPadding(); syncScrollLock(); });
})();
